import React, {useState } from "react";
import { Card, Nav } from "react-bootstrap";
import OracionesDevocionario from '../components/OracionesDevocionario';
import OracionesMensajes from '../components/OracionesMensajes';
import PromesasJesus from '../components/PromesasJesus';

export default function SantoRosario() {
  const [subNav, setSubNav] = useState("1");

  const handleSelect = (eventKey) => {
    setSubNav(eventKey);
  };

  return (
    <>
      <Card className="pt-5 rosario">
        <Card.Header>
          <Nav variant="tabs" defaultActiveKey="1" onSelect={handleSelect}>
            <Nav.Item>
              <Nav.Link eventKey="1">Devocionario</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="2">Oraciones en Mensajes</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="3">Promesas de Jesús</Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>
        {subNav === "1" && <OracionesDevocionario />}
        {subNav === "2" && <OracionesMensajes />}
        {subNav === "3" && <PromesasJesus />}
      </Card>
    </>
  );
}
